import React from 'react';
import { RoofQuiz } from '../components/RoofQuiz';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const QuizPage = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-20 min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-12">
        <Button
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Button>
        <RoofQuiz onClose={() => navigate('/contact')} />
      </div>
    </div>
  );
};
